export enum BookingLifecycleStatus {
  PENDING_APPROVAL = "pending_approval",
  REJECTED = "rejected",
  SCHEDULED = "scheduled",
  AWAITING_VIDEO = "awaiting_video",
  ARTIST_REVIEW = "artist_review",
  READY_TO_POST = "ready_to_post",
  POSTED = "posted",
  CANCELLED = "cancelled",
  NO_SHOW = "no_show"
}

// Helper functions for status checks
export const isPrePerformance = (status: BookingLifecycleStatus): boolean => {
  return [
    BookingLifecycleStatus.PENDING_APPROVAL,
    BookingLifecycleStatus.SCHEDULED
  ].includes(status);
};

export const isPostPerformance = (status: BookingLifecycleStatus): boolean => {
  return [
    BookingLifecycleStatus.AWAITING_VIDEO,
    BookingLifecycleStatus.ARTIST_REVIEW,
    BookingLifecycleStatus.READY_TO_POST,
    BookingLifecycleStatus.POSTED
  ].includes(status);
};

export const isTerminalState = (status: BookingLifecycleStatus): boolean => {
  return [
    BookingLifecycleStatus.REJECTED,
    BookingLifecycleStatus.POSTED,
    BookingLifecycleStatus.CANCELLED,
    BookingLifecycleStatus.NO_SHOW
  ].includes(status);
};

// Status display configuration
export const statusConfig: Record<BookingLifecycleStatus, { label: string; color: string; description: string }> = {
  [BookingLifecycleStatus.PENDING_APPROVAL]: {
    label: "Pending Review",
    color: "bg-orange-500 text-white",
    description: "Waiting for admin approval"
  },
  [BookingLifecycleStatus.REJECTED]: {
    label: "Rejected",
    color: "bg-red-500",
    description: "Booking was not approved"
  },
  [BookingLifecycleStatus.SCHEDULED]: {
    label: "Scheduled",
    color: "bg-green-500",
    description: "Approved and scheduled for performance"
  },
  [BookingLifecycleStatus.AWAITING_VIDEO]: {
    label: "Awaiting Video",
    color: "bg-gray-500",
    description: "Performance completed, waiting for video upload"
  },
  [BookingLifecycleStatus.ARTIST_REVIEW]: {
    label: "Artist Review",
    color: "bg-orange-500",
    description: "Video uploaded, artist needs to review"
  },
  [BookingLifecycleStatus.READY_TO_POST]: {
    label: "Ready to Post",
    color: "bg-green-500/15 border border-green-500/30 text-green-400",
    description: "Artist approved, ready to post publicly"
  },
  [BookingLifecycleStatus.POSTED]: {
    label: "Posted",
    color: "bg-green-500",
    description: "Video is live on the platform"
  },
  [BookingLifecycleStatus.CANCELLED]: {
    label: "Cancelled",
    color: "bg-gray-500",
    description: "Booking was cancelled"
  },
  [BookingLifecycleStatus.NO_SHOW]: {
    label: "No Show",
    color: "bg-red-500",
    description: "Artist did not perform"
  }
};